'use client'

import * as React from 'react'

import { cn } from '@/lib/utils'

function IconNextChat({
  className,
  inverted,
  ...props
}: React.ComponentProps<'svg'> & { inverted?: boolean }) {
  const id = React.useId()

  return (
    <svg
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-4', className)}
      {...props}
    >
      <defs>
        <linearGradient
          id={`gradient-${id}-1`}
          x1="10.6889"
          y1="10.3556"
          x2="13.8445"
          y2="14.2667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={inverted ? 'white' : 'black'} />
          <stop
            offset={1}
            stopColor={inverted ? 'white' : 'black'}
            stopOpacity={0}
          />
        </linearGradient>
        <linearGradient
          id={`gradient-${id}-2`}
          x1="11.7555"
          y1="4.8"
          x2="11.7376"
          y2="9.50002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={inverted ? 'white' : 'black'} />
          <stop
            offset={1}
            stopColor={inverted ? 'white' : 'black'}
            stopOpacity={0}
          />
        </linearGradient>
      </defs>
      <path
        d="M1 16L2.58314 11.2506C1.83084 9.74642 1.63835 8.02363 2.04013 6.39052C2.4419 4.75741 3.41171 3.32057 4.776 2.33712C6.1403 1.35367 7.81003 0.887808 9.4864 1.02289C11.1628 1.15798 12.7364 1.8852 13.9256 3.07442C15.1148 4.26363 15.842 5.83723 15.9771 7.5136C16.1122 9.18997 15.6463 10.8597 14.6629 12.224C13.6794 13.5883 12.2426 14.5581 10.6095 14.9599C8.97637 15.3616 7.25358 15.1692 5.74942 14.4169L1 16Z"
        fill={inverted ? 'black' : 'white'}
        stroke={inverted ? 'black' : 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask
        id="mask0_91_2047"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={0}
        width={16}
        height={16}
      >
        <circle cx={9} cy={8} r={8} fill={inverted ? 'black' : 'white'} />
      </mask>
      <g mask="url(#mask0_91_2047)">
        <circle cx={9} cy={8} r={8} fill={inverted ? 'black' : 'white'} />
        <path
          d="M14.2896 14.0018L7.146 4.8H5.80005V11.1973H6.87681V6.16743L13.4444 14.6529C13.7407 14.4545 14.0231 14.2369 14.2896 14.0018Z"
          fill={`url(#gradient-${id}-1)`}
        />
        <rect
          x="11.2222"
          y="4.8"
          width="1.06667"
          height="6.4"
          fill={`url(#gradient-${id}-2)`}
        />
      </g>
    </svg>
  )
}

function IconOpenAI({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 24 24"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-4', className)}
      {...props}
    >
      <title>OpenAI icon</title>
      <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" />
    </svg>
  )
}

function IconVercel({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      aria-label="Vercel logomark"
      role="img"
      viewBox="0 0 74 64"
      className={cn('size-4', className)}
      {...props}
    >
      <path
        d="M37.5896 0.25L74.5396 64.25H0.639648L37.5896 0.25Z"
        fill="currentColor"
      ></path>
    </svg>
  )
}

function IconGitHub({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <title>GitHub</title>
      <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
    </svg>
  )
}

function IconSeparator({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      fill="none"
      shapeRendering="geometricPrecision"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M16.88 3.549L7.12 20.451"></path>
    </svg>
  )
}

function IconArrowDown({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="m205.66 149.66-72 72a8 8 0 0 1-11.32 0l-72-72a8 8 0 0 1 11.32-11.32L120 196.69V40a8 8 0 0 1 16 0v156.69l58.34-58.35a8 8 0 0 1 11.32 11.32Z" />
    </svg>
  )
}

function IconArrowRight({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="m221.66 133.66-72 72a8 8 0 0 1-11.32-11.32L196.69 136H40a8 8 0 0 1 0-16h156.69l-58.35-58.34a8 8 0 0 1 11.32-11.32l72 72a8 8 0 0 1 0 11.32Z" />
    </svg>
  )
}

function IconUser({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M230.92 212c-15.23-26.33-38.7-45.21-66.09-54.16a72 72 0 1 0-73.66 0c-27.39 8.94-50.86 27.82-66.09 54.16a8 8 0 1 0 13.85 8c18.84-32.56 52.14-52 89.07-52s70.23 19.44 89.07 52a8 8 0 1 0 13.85-8ZM72 96a56 56 0 1 1 56 56 56.06 56.06 0 0 1-56-56Z" />
    </svg>
  )
}

function IconPlus({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M224 128a8 8 0 0 1-8 8h-80v80a8 8 0 0 1-16 0v-80H40a8 8 0 0 1 0-16h80V40a8 8 0 0 1 16 0v80h80a8 8 0 0 1 8 8Z" />
    </svg>
  )
}

function IconPlusCircle({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21.625C7.22656 21.625 3.78125 19.6562 1.89453 16.375C0.0078125 13.1348 0.0078125 9.15625 1.89453 5.875C3.78125 2.63477 7.22656 0.625 11 0.625C14.7324 0.625 18.1777 2.63477 20.0645 5.875C21.9512 9.15625 21.9512 13.1348 20.0645 16.375C18.1777 19.6562 14.7324 21.625 11 21.625ZM10.0156 14.7344C10.0156 15.3086 10.4258 15.7188 11 15.7188C11.5332 15.7188 11.9844 15.3086 11.9844 14.7344V12.1094H14.6094C15.1426 12.1094 15.5938 11.6992 15.5938 11.125C15.5938 10.5918 15.1426 10.1406 14.6094 10.1406H11.9844V7.51562C11.9844 6.98242 11.5332 6.53125 11 6.53125C10.4258 6.53125 10.0156 6.98242 10.0156 7.51562V10.1406H7.39062C6.81641 10.1406 6.40625 10.5918 6.40625 11.125C6.40625 11.6992 6.81641 12.1094 7.39062 12.1094H10.0156V14.7344Z"
        fill="black"
      />
    </svg>
  )
}

function IconArrowElbow({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M200 32v144a8 8 0 0 1-8 8H67.31l34.35 34.34a8 8 0 0 1-11.32 11.32l-48-48a8 8 0 0 1 0-11.32l48-48a8 8 0 0 1 11.32 11.32L67.31 168H184V32a8 8 0 0 1 16 0Z" />
    </svg>
  )
}

function IconSpinner({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4 animate-spin', className)}
      {...props}
    >
      <path d="M232 128a104 104 0 0 1-208 0c0-41 23.81-78.36 60.66-95.27a8 8 0 0 1 6.68 14.54C60.15 61.59 40 93.27 40 128a88 88 0 0 0 176 0c0-34.73-20.15-66.41-51.34-80.73a8 8 0 0 1 6.68-14.54C208.19 49.64 232 87 232 128Z" />
    </svg>
  )
}

function IconMessage({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M216 48H40a16 16 0 0 0-16 16v160a15.84 15.84 0 0 0 9.25 14.5A16.05 16.05 0 0 0 40 240a15.89 15.89 0 0 0 10.25-3.78.69.69 0 0 0 .13-.11L82.5 208H216a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16ZM40 224Zm176-32H82.5a16 16 0 0 0-10.3 3.75l-.12.11L40 224V64h176Z" />
    </svg>
  )
}

function IconTrash({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M216 48h-40v-8a24 24 0 0 0-24-24h-48a24 24 0 0 0-24 24v8H40a8 8 0 0 0 0 16h8v144a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V64h8a8 8 0 0 0 0-16ZM96 40a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v8H96Zm96 168H64V64h128Zm-80-104v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0Zm48 0v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0Z" />
    </svg>
  )
}

function IconRefresh({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M197.67 186.37a8 8 0 0 1 0 11.29C196.58 198.73 170.82 224 128 224c-37.39 0-64.53-22.4-80-39.85V208a8 8 0 0 1-16 0v-48a8 8 0 0 1 8-8h48a8 8 0 0 1 0 16H55.44C67.76 183.35 93 208 128 208c36 0 58.14-21.46 58.36-21.68a8 8 0 0 1 11.31.05ZM216 40a8 8 0 0 0-8 8v23.85C192.53 54.4 165.39 32 128 32c-42.82 0-68.58 25.27-69.66 26.34a8 8 0 0 0 11.3 11.34C69.86 69.46 92 48 128 48c35 0 60.24 24.65 72.56 40H168a8 8 0 0 0 0 16h48a8 8 0 0 0 8-8V48a8 8 0 0 0-8-8Z" />
    </svg>
  )
}

function IconStop({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24Zm0 192a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88Zm24-120h-48a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8Zm-8 48h-32v-32h32Z" />
    </svg>
  )
}

function IconSidebar({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M216 40H40a16 16 0 0 0-16 16v144a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16ZM40 56h40v144H40Zm176 144H96V56h120v144Z" />
    </svg>
  )
}

function IconMoon({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M233.54 142.23a8 8 0 0 0-8-2 88.08 88.08 0 0 1-109.8-109.8 8 8 0 0 0-10-10 104.84 104.84 0 0 0-52.91 37A104 104 0 0 0 136 224a103.09 103.09 0 0 0 62.52-20.88 104.84 104.84 0 0 0 37-52.91 8 8 0 0 0-1.98-7.98Zm-44.64 48.11A88 88 0 0 1 65.66 67.11a89 89 0 0 1 31.4-26A106 106 0 0 0 96 56a104.11 104.11 0 0 0 104 104 106 106 0 0 0 14.92-1.06 89 89 0 0 1-26.02 31.4Z" />
    </svg>
  )
}

function IconSun({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M120 40V16a8 8 0 0 1 16 0v24a8 8 0 0 1-16 0Zm72 88a64 64 0 1 1-64-64 64.07 64.07 0 0 1 64 64Zm-16 0a48 48 0 1 0-48 48 48.05 48.05 0 0 0 48-48ZM58.34 69.66a8 8 0 0 0 11.32-11.32l-16-16a8 8 0 0 0-11.32 11.32Zm0 116.68-16 16a8 8 0 0 0 11.32 11.32l16-16a8 8 0 0 0-11.32-11.32ZM192 72a8 8 0 0 0 5.66-2.34l16-16a8 8 0 0 0-11.32-11.32l-16 16A8 8 0 0 0 192 72Zm5.66 114.34a8 8 0 0 0-11.32 11.32l16 16a8 8 0 0 0 11.32-11.32ZM48 128a8 8 0 0 0-8-8H16a8 8 0 0 0 0 16h24a8 8 0 0 0 8-8Zm80 80a8 8 0 0 0-8 8v24a8 8 0 0 0 16 0v-24a8 8 0 0 0-8-8Zm112-88h-24a8 8 0 0 0 0 16h24a8 8 0 0 0 0-16Z" />
    </svg>
  )
}

function IconCopy({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M216 32H88a8 8 0 0 0-8 8v40H40a8 8 0 0 0-8 8v128a8 8 0 0 0 8 8h128a8 8 0 0 0 8-8v-40h40a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8Zm-56 176H48V96h112Zm48-48h-32V88a8 8 0 0 0-8-8H96V48h112Z" />
    </svg>
  )
}

function IconCheck({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="m229.66 77.66-128 128a8 8 0 0 1-11.32 0l-56-56a8 8 0 0 1 11.32-11.32L96 188.69 218.34 66.34a8 8 0 0 1 11.32 11.32Z" />
    </svg>
  )
}

export function IconFileText({
  className,
  ...props
}: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
      <path d="M14 2v4a2 2 0 0 0 2 2h4" />
      <path d="M10 9H8" />
      <path d="M16 13H8" />
      <path d="M16 17H8" />
    </svg>
  )
}

export const IconFileGraph = ({
  className,
  ...props
}: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1968 24C10.1968 24.3691 10.4839 24.6562 10.853 24.6562H21.353C21.6812 24.6562 22.0093 24.3691 22.0093 24V12.1875H18.728C17.9897 12.1875 17.4155 11.6133 17.4155 10.875V7.59375H10.853C10.4839 7.59375 10.1968 7.92188 10.1968 8.25V24ZM10.853 5.625H17.6206C18.3179 5.625 18.9741 5.91211 19.4663 6.4043L23.1987 10.1367C23.6909 10.6289 23.978 11.2852 23.978 11.9824V24C23.978 25.4766 22.7886 26.625 21.353 26.625H10.853C9.37646 26.625 8.22803 25.4766 8.22803 24V8.25C8.22803 6.81445 9.37646 5.625 10.853 5.625ZM12.1655 9.5625H15.4468C15.7749 9.5625 16.103 9.89062 16.103 10.2188C16.103 10.5879 15.7749 10.875 15.4468 10.875H12.1655C11.7964 10.875 11.5093 10.5879 11.5093 10.2188C11.5093 9.89062 11.7964 9.5625 12.1655 9.5625ZM12.1655 12.1875H15.4468C15.7749 12.1875 16.103 12.5156 16.103 12.8438C16.103 13.2129 15.7749 13.5 15.4468 13.5H12.1655C11.7964 13.5 11.5093 13.2129 11.5093 12.8438C11.5093 12.5156 11.7964 12.1875 12.1655 12.1875ZM14.3804 21.293C14.1343 22.1543 13.355 22.6875 12.4937 22.6875H12.1655C11.7964 22.6875 11.5093 22.4004 11.5093 22.0312C11.5093 21.7031 11.7964 21.375 12.1655 21.375H12.4937C12.7808 21.375 13.0269 21.2109 13.1089 20.9238L13.7241 18.9141C13.8472 18.4219 14.2983 18.0938 14.7905 18.0938C15.2417 18.0938 15.6929 18.4219 15.8159 18.873L16.2671 20.4316C16.5542 20.1855 16.8823 20.0625 17.2515 20.0625C17.7847 20.0625 18.2769 20.3906 18.5229 20.8828L18.769 21.375H20.0405C20.3687 21.375 20.6968 21.7031 20.6968 22.0312C20.6968 22.4004 20.3687 22.6875 20.0405 22.6875H18.3999C18.1538 22.6875 17.9077 22.5645 17.7847 22.3594L17.3745 21.457C17.3335 21.416 17.2925 21.375 17.2515 21.375C17.1694 21.375 17.1284 21.416 17.0874 21.457L16.6772 22.3594C16.5542 22.5645 16.3081 22.7285 16.021 22.6875C15.7749 22.6875 15.5288 22.4824 15.4468 22.2363L14.7905 19.9395L14.3804 21.293Z"
        fill="black"
      />
    </svg>
  )
}

function IconDownload({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M224 152v56a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16v-56a8 8 0 0 1 16 0v56h160v-56a8 8 0 0 1 16 0Zm-101.66 5.66a8 8 0 0 0 11.32 0l40-40a8 8 0 0 0-11.32-11.32L136 132.69V40a8 8 0 0 0-16 0v92.69l-26.34-26.35a8 8 0 0 0-11.32 11.32Z" />
    </svg>
  )
}

function IconClose({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M205.66 194.34a8 8 0 0 1-11.32 11.32L128 139.31l-66.34 66.35a8 8 0 0 1-11.32-11.32L116.69 128 50.34 61.66a8 8 0 0 1 11.32-11.32L128 116.69l66.34-66.35a8 8 0 0 1 11.32 11.32L139.31 128Z" />
    </svg>
  )
}

function IconEdit({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
      />
    </svg>
  )
}

function IconShare({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn('size-4', className)}
      viewBox="0 0 256 256"
      {...props}
    >
      <path d="m237.66 106.35-80-80A8 8 0 0 0 144 32v40.35c-25.94 2.22-54.59 14.92-78.16 34.91-28.38 24.08-46.05 55.11-49.76 87.37a12 12 0 0 0 20.68 9.58c11-11.71 50.14-48.74 107.24-52V192a8 8 0 0 0 13.66 5.65l80-80a8 8 0 0 0 0-11.3ZM160 172.69V144a8 8 0 0 0-8-8c-28.08 0-55.43 7.33-81.29 21.8a196.17 196.17 0 0 0-36.57 26.52c5.8-23.84 20.42-46.51 42.05-64.86C99.41 99.77 127.75 88 152 88a8 8 0 0 0 8-8V51.32L220.69 112Z" />
    </svg>
  )
}

function IconUsers({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn('size-4', className)}
      viewBox="0 0 256 256"
      {...props}
    >
      <path d="M117.25 157.92a60 60 0 1 0-66.5 0 95.83 95.83 0 0 0-47.22 37.71 8 8 0 1 0 13.4 8.74 80 80 0 0 1 134.14 0 8 8 0 0 0 13.4-8.74 95.83 95.83 0 0 0-47.22-37.71ZM40 108a44 44 0 1 1 44 44 44.05 44.05 0 0 1-44-44Zm210.14 98.7a8 8 0 0 1-11.07-2.33A79.83 79.83 0 0 0 172 168a8 8 0 0 1 0-16 44 44 0 1 0-16.34-84.87 8 8 0 1 1-5.94-14.85 60 60 0 0 1 55.53 105.64 95.83 95.83 0 0 1 47.22 37.71 8 8 0 0 1-2.33 11.07Z" />
    </svg>
  )
}

function IconExternalLink({
  className,
  ...props
}: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn('size-4', className)}
      viewBox="0 0 256 256"
      {...props}
    >
      <path d="M224 104a8 8 0 0 1-16 0V59.32l-66.33 66.34a8 8 0 0 1-11.32-11.32L196.68 48H152a8 8 0 0 1 0-16h64a8 8 0 0 1 8 8Zm-40 24a8 8 0 0 0-8 8v72H48V80h72a8 8 0 0 0 0-16H48a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-72a8 8 0 0 0-8-8Z" />
    </svg>
  )
}

function IconChevronUpDown({
  className,
  ...props
}: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn('size-4', className)}
      viewBox="0 0 256 256"
      {...props}
    >
      <path d="M181.66 170.34a8 8 0 0 1 0 11.32l-48 48a8 8 0 0 1-11.32 0l-48-48a8 8 0 0 1 11.32-11.32L128 212.69l42.34-42.35a8 8 0 0 1 11.32 0Zm-96-84.68L128 43.31l42.34 42.35a8 8 0 0 0 11.32-11.32l-48-48a8 8 0 0 0-11.32 0l-48 48a8 8 0 0 0 11.32 11.32Z" />
    </svg>
  )
}

function IconChevronDown({
  className,
  ...props
}: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn('size-4', className)}
      viewBox="0 0 512 512"
      {...props}
    >
      <path d="M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z" />
    </svg>
  )
}

function IconRobot({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zm-2 10H6V7h12v12zm-9-6c-.83 0-1.5-.67-1.5-1.5S8.17 10 9 10s1.5.67 1.5 1.5S9.83 13 9 13zm7.5-1.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5zM8 15h8v2H8v-2z" />
    </svg>
  )
}

function IconMatter({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 20"
      fill="currentColor"
      className={cn('size-4', className)}
      {...props}
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Artboard" stroke="currentColor">
          <g id="matter-icon-orange">
            <path
              d="M3,19.4995 L20.5,19.4995 C22.155,19.4995 23.5,18.1565 23.5,16.4995 L23.5,4.4995 L5.5,4.4995 L5.5,16.9995 C5.5,18.3805 4.38,19.4995 3,19.4995 C1.618,19.4995 0.5,18.3805 0.5,16.9995 L0.5,0.4995 L7.5,0.4995 L7.5,2.4995 L20.5,2.4995 L20.5,4.4995"
              id="Stroke-370"
            ></path>
            <path d="M10.5,8.5 L10.5,15.5" id="Stroke-2579"></path>
            <path d="M10.5,8.5 L14.5,11.5" id="Stroke-2579-Copy-2"></path>
            <path d="M18.5,8.5 L14.5,11.5" id="Stroke-2579-Copy-3"></path>
            <path d="M18.5,8.5 L18.5,15.5" id="Stroke-2579-Copy"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

function IconSmokeballLogo({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg 
      width="16" 
      height="16" 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
      {...props}
    >
      <path 
        d="M7.35631 7.22976C4.11229 6.05454 3.28936 3.59146 3.8951 1.8C3.97578 1.55799 4.08795 1.30452 4.23306 1.04055C4.27602 0.960836 4.26266 0.859163 4.19822 0.792812C4.13377 0.726939 4.03449 0.71596 3.95716 0.76274C1.51747 2.21242 0 4.89317 0 7.75531C0 9.4093 0.487843 10.9974 1.41293 12.354C2.26833 13.6089 3.51753 14.6052 5.02688 15.23C5.83931 15.5656 6.62454 15.7336 7.4155 15.7336C7.61932 15.7336 7.82315 15.7226 8.02697 15.7007C10.1745 15.4696 11.26 14.209 11.26 11.955C11.26 10.342 9.80172 8.13241 7.35678 7.22976M9.75638 11.955C9.75638 13.4381 9.26328 14.0161 7.86897 14.1679C6.71094 14.2915 5.74003 14.0056 4.287 13.1082C4.08318 12.9846 3.91181 12.8605 3.76431 12.7311C2.3299 11.4814 1.50697 9.66802 1.50697 7.75531C1.50697 6.56625 1.81819 5.41873 2.41296 4.40581C2.97622 6.29083 4.60348 7.86796 6.85271 8.67992C8.59023 9.32385 9.75638 10.8924 9.75638 11.955Z" 
        fill="currentColor"
      />
      <path 
        d="M15.6193 5.29205C15.3701 4.4968 15.0026 3.7426 14.5257 3.06573C14.0484 2.386 13.3462 1.72536 12.6435 1.29909C11.9786 0.891919 11.4774 0.641314 10.7184 0.47329C10.0993 0.335339 9.45873 0.266602 8.81002 0.266602C6.46914 0.266602 5.4209 1.55208 5.4209 2.82897C5.4209 4.46386 6.60566 5.20422 9.25729 6.25007C12.6459 7.5408 14.0908 9.22248 14.0908 11.8727C14.0908 12.065 14.0827 12.2579 14.0641 12.4421C14.056 12.5328 14.1071 12.6211 14.193 12.6541C14.2169 12.6622 14.2412 12.6679 14.2656 12.6679C14.3271 12.6679 14.3863 12.6374 14.4264 12.5853C15.456 11.1791 16.0002 9.50841 16.0002 7.75561C16.0002 6.92169 15.8689 6.08778 15.6198 5.29253M14.4966 7.76372C14.4966 7.82435 14.4565 7.84917 14.4321 7.85728C14.4135 7.8654 14.3543 7.87924 14.3114 7.82148C13.3648 6.59424 11.8851 5.60614 9.78332 4.80516C7.32501 3.83664 6.92834 3.42899 6.92834 2.82897C6.92834 2.1879 7.63099 1.80794 8.8105 1.80794C9.34942 1.80794 9.88547 1.86569 10.4029 1.97835C10.7838 2.06379 11.0545 2.16547 11.4058 2.34972C12.3762 2.86716 13.1619 3.62947 13.6713 4.55122C14.2102 5.52833 14.4971 6.6372 14.4971 7.75465V7.76277L14.4966 7.76372Z" 
        fill="currentColor"
      />
    </svg>
  )
}


function IconArchieAvatar({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}
      {...props}>
      <path d="M0 8C0 3.58172 3.58172 0 8 0H30C34.4183 0 38 3.58172 38 8V30C38 34.4183 34.4183 38 30 38H8C3.58172 38 0 34.4183 0 30V8Z" fill="url(#paint0_linear_161_1060)" />
      <path d="M17.3232 31.2539L17.1687 30.6829C17.1162 30.4325 17.0644 30.1673 17.0111 29.8912C16.3531 26.4959 15.2457 21.6373 7.22082 20.5164L6.35183 20.3947L6.27026 18.3566L7.22396 18.2333C15.0308 17.2279 15.9782 11.6275 16.4213 8.15651C16.4433 7.98569 16.4637 7.82189 16.4848 7.66589L16.6033 6.77825L18.5828 6.73535L18.753 7.59881C18.8032 7.85231 18.851 8.12219 18.9012 8.40377C19.5075 11.796 20.3381 16.4417 28.5888 17.7981L29.4335 17.9369L29.515 19.9681L28.5739 20.1007C25.0901 20.5905 22.7145 21.8814 21.3121 24.0482C20.1122 25.9023 19.8291 28.0644 19.6024 29.8015C19.5655 30.0831 19.5302 30.3514 19.4934 30.6026L19.4173 31.2453L17.324 31.2554L17.3232 31.2539ZM11.2827 19.3417C15.3084 20.7839 17.2785 23.5607 18.1805 26.0068C18.9405 23.3689 20.5773 20.4938 24.6171 18.9424C22.2407 18.082 20.4384 16.7981 19.1554 15.0611C18.5185 14.1992 18.0691 13.2967 17.7381 12.4106C16.935 15.0845 15.07 17.7848 11.2827 19.3417Z" fill="white" />
      <path d="M31.7298 8.69387C28.4743 8.05661 28.4703 6.06059 28.2837 4.92725H28.1449C27.9574 6.06137 27.7504 8.39591 24.6956 8.69465V8.88029C27.8688 9.42239 27.926 11.42 28.1315 12.572H28.2962C28.5017 11.4207 28.5778 9.22583 31.7298 8.88107V8.69387Z" fill="white" />
      <path d="M31.7298 29.1954C28.4743 28.5581 28.4703 26.5621 28.2837 25.428H28.1449C27.9574 26.5621 27.7504 28.8966 24.6956 29.1954V29.381C27.8688 29.9239 27.926 31.9207 28.1315 33.0728H28.2962C28.5017 31.9215 28.5778 29.7266 31.7298 29.381V29.1954Z" fill="white" />
      <defs>
        <linearGradient id="paint0_linear_161_1060" x1="0" y1="19" x2="38" y2="19" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F98542" />
          <stop offset="1" stopColor="#F2600C" />
        </linearGradient>
      </defs>
    </svg>
  )
}

function IconArchieText({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg width="73" height="21" viewBox="0 0 73 21" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}
      {...props}>
      <rect x="0.956055" y="0.400513" width="71.5435" height="20.2795" rx="5" fill="url(#paint0_linear_152_234)" />
      <path d="M57.7182 17.014L57.6366 16.7123C57.6088 16.5801 57.5815 16.44 57.5533 16.2941C57.2057 14.5003 56.6206 11.9335 52.3811 11.3414L51.922 11.2771L51.8789 10.2003L52.3827 10.1352C56.5071 9.60405 57.0076 6.64535 57.2417 4.81162C57.2533 4.72138 57.2641 4.63484 57.2753 4.55243L57.3378 4.08349L58.3836 4.06082L58.4735 4.51699C58.5001 4.65091 58.5253 4.79349 58.5519 4.94225C58.8721 6.73436 59.3109 9.18868 63.6698 9.90527L64.116 9.97862L64.1591 11.0517L63.6619 11.1217C61.8214 11.3805 60.5664 12.0625 59.8255 13.2072C59.1916 14.1867 59.042 15.329 58.9223 16.2467C58.9028 16.3954 58.8842 16.5372 58.8647 16.6699L58.8245 17.0094L57.7186 17.0148L57.7182 17.014ZM54.527 10.7208C56.6538 11.4827 57.6946 12.9497 58.1711 14.2419C58.5726 12.8483 59.4373 11.3294 61.5716 10.5098C60.3161 10.0553 59.364 9.377 58.6861 8.45931C58.3497 8.00396 58.1122 7.52719 57.9374 7.05908C57.5131 8.47167 56.5278 9.89827 54.527 10.7208Z" fill="white" />
      <path d="M65.3295 5.09553C63.6096 4.75886 63.6075 3.70437 63.5089 3.10562H63.4356C63.3365 3.70478 63.2271 4.93812 61.6133 5.09594V5.19401C63.2897 5.48041 63.3199 6.53573 63.4285 7.14436H63.5155C63.6241 6.53614 63.6643 5.37656 65.3295 5.19443V5.09553Z" fill="white" />
      <path d="M65.3295 15.9265C63.6096 15.5898 63.6075 14.5353 63.5089 13.9362H63.4356C63.3365 14.5353 63.2271 15.7687 61.6133 15.9265V16.0246C63.2897 16.3114 63.3199 17.3663 63.4285 17.9749H63.5155C63.6241 17.3667 63.6643 16.2071 65.3295 16.0246V15.9265Z" fill="white" />
      <path d="M11.1323 6.44644L8.12598 14.6341H9.16619L9.98968 12.3153H13.3004L14.1239 14.6341H15.1641L12.1568 6.44644H11.1333H11.1323ZM10.301 11.4357L11.6121 7.74178H11.6761L12.9872 11.4357H10.301Z" fill="white" />
      <path d="M20.6746 11.1185C21.0824 10.9067 21.3849 10.6142 21.5819 10.2408C21.7789 9.86849 21.8784 9.44 21.8784 8.95733C21.8784 8.47465 21.7789 8.04517 21.5819 7.66593C21.3849 7.28669 21.0815 6.9892 20.6707 6.77249C20.2599 6.55578 19.7349 6.44644 19.0956 6.44644H16.3286V14.6341H17.3196V11.4357H19.1104C19.1843 11.4357 19.2404 11.4199 19.3113 11.417L21.046 14.6332H22.1965L20.3348 11.2328C20.4481 11.1934 20.5752 11.1688 20.6737 11.1165L20.6746 11.1185ZM17.3206 7.32609H19.0641C19.5064 7.32609 19.863 7.39307 20.1319 7.52802C20.4008 7.66297 20.5968 7.85309 20.72 8.09738C20.8421 8.34266 20.9042 8.6293 20.9042 8.95733C20.9042 9.28535 20.8431 9.56707 20.7219 9.8025C20.6008 10.0389 20.4067 10.2202 20.1378 10.3482C19.8708 10.4763 19.5172 10.5403 19.0808 10.5403H17.3215V7.32609H17.3206Z" fill="white" />
      <path d="M25.3618 7.63735C25.7628 7.38715 26.211 7.26205 26.7064 7.26205C26.9783 7.26205 27.2393 7.29948 27.4905 7.37435C27.7407 7.44921 27.9693 7.55953 28.1751 7.70828C28.382 7.85603 28.5583 8.03827 28.7031 8.25399C28.8479 8.46972 28.9504 8.71992 29.0095 9.00558H30.0014C29.9265 8.58497 29.7906 8.20967 29.5936 7.87968C29.3966 7.55067 29.1513 7.27092 28.8578 7.04042C28.5642 6.80991 28.2362 6.63458 27.8727 6.5144C27.5083 6.39422 27.1192 6.33414 26.7064 6.33414C26.008 6.33414 25.3875 6.50455 24.8427 6.84636C24.299 7.18719 23.8725 7.67282 23.5592 8.30128C23.2479 8.93072 23.0913 9.6764 23.0913 10.5403C23.0913 11.4042 23.2469 12.1499 23.5592 12.7783C23.8715 13.4078 24.299 13.8924 24.8427 14.2342C25.3875 14.575 26.008 14.7464 26.7064 14.7464C27.1192 14.7464 27.5073 14.6863 27.8727 14.5662C28.2362 14.446 28.5642 14.2707 28.8578 14.0402C29.1513 13.8097 29.3966 13.5289 29.5936 13.1989C29.7906 12.8689 29.9265 12.4946 30.0014 12.076H29.0095C28.9504 12.3587 28.8489 12.6079 28.7031 12.8256C28.5573 13.0433 28.382 13.2255 28.1751 13.3733C27.9693 13.521 27.7407 13.6323 27.4905 13.7072C27.2393 13.7821 26.9783 13.8185 26.7064 13.8185C26.211 13.8185 25.7628 13.6934 25.3618 13.4432C24.9609 13.193 24.6428 12.8236 24.4054 12.336C24.1699 11.8484 24.0527 11.2495 24.0527 10.5413C24.0527 9.83302 24.1699 9.23411 24.4054 8.74652C24.6418 8.25892 24.9599 7.88953 25.3618 7.63834V7.63735Z" fill="white" />
      <path d="M36.8435 10.0931H32.4778V6.44644H31.4868V14.6341H32.4778V10.9717H36.8435V14.6341H37.8345V6.44644H36.8435V10.0931Z" fill="white" />
      <path d="M40.698 6.44644H39.707V14.6341H40.698V6.44644Z" fill="white" />
      <path d="M43.5593 13.7545V10.9717H47.2532V10.0931H43.5593V7.32609H47.5094V6.44644H42.5684V14.6341H47.5734V13.7545H43.5593Z" fill="white" />
      <defs>
        <linearGradient id="paint0_linear_152_234" x1="0.956055" y1="10.5403" x2="72.4995" y2="10.5403" gradientUnits="userSpaceOnUse">
          <stop stop-color="#F98542" />
          <stop offset="0.99" stop-color="#F2600C" />
        </linearGradient>
      </defs>
    </svg>
  )
}

function IconArchieDraft({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg width="31" height="39" viewBox="0 0 31 39" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}
      {...props}>
      <g clip-path="url(#clip0_160_1040)">
        <path d="M3.25168 0.74826H21.7722L29.6372 8.9194V36.0069C29.6372 37.249 28.6686 38.2517 27.4686 38.2517H3.25168C2.05168 38.2517 1.08301 37.249 1.08301 36.0069V2.99308C1.08301 1.75095 2.05168 0.74826 3.25168 0.74826Z" fill="url(#paint0_linear_160_1040)" stroke="url(#paint1_linear_160_1040)" />
        <path d="M11.1457 19.6496L11.0734 19.3503C11.0445 19.2156 11.0156 19.081 11.0011 18.9463C10.6686 17.2103 10.1337 14.711 6.15777 14.1423L5.72404 14.0825L5.68066 13.0349L6.15777 12.975C10.018 12.4662 10.4951 9.59285 10.712 7.81196C10.712 7.72217 10.7264 7.64734 10.7409 7.55755L10.7987 7.10858H11.7819L11.8686 7.52761C11.8975 7.6623 11.912 7.79699 11.9409 7.94665C12.2445 9.68264 12.6493 12.0622 16.7409 12.7655L17.1602 12.8404L17.2036 13.8879L16.7409 13.9628C15.0204 14.2172 13.8349 14.8757 13.1409 15.9831C12.5481 16.9409 12.4036 18.0483 12.2879 18.9313C12.2734 19.081 12.259 19.2156 12.2301 19.3354L12.1867 19.6646H11.1457V19.6496ZM8.15295 13.5437C10.1481 14.277 11.1168 15.7137 11.565 16.9559C11.9409 15.609 12.7505 14.1274 14.7602 13.3342C13.5891 12.9002 12.6927 12.2417 12.0566 11.3438C11.7385 10.8948 11.5216 10.4459 11.3481 9.98195C10.9433 11.3588 10.0325 12.7356 8.15295 13.5288V13.5437Z" fill="white" />
        <path d="M18.2734 8.08136C16.6541 7.75212 16.6541 6.73447 16.5674 6.15082H16.4951C16.4083 6.73447 16.2927 7.93171 14.7891 8.08136V8.17116C16.365 8.4555 16.3939 9.47315 16.4951 10.0568H16.5818C16.683 9.47315 16.7264 8.33578 18.2879 8.17116V8.08136H18.2734Z" fill="white" />
        <path d="M18.2734 18.6021C16.6541 18.2728 16.6541 17.2552 16.5674 16.6715H16.4951C16.4083 17.2552 16.2927 18.4524 14.7891 18.6021V18.6919C16.365 18.9762 16.3939 19.9939 16.4951 20.5775H16.5818C16.683 19.9939 16.7264 18.8565 18.2879 18.6919V18.6021H18.2734Z" fill="white" />
        <path d="M28.9434 9.11398L21.5988 1.33194C21.4687 1.21222 21.3096 1.13739 21.1506 1.13739H3.61323C2.4566 1.13739 1.51685 2.14008 1.51685 3.36724V35.6328C1.51685 36.86 2.4566 37.8626 3.61323 37.8626H27.0349C28.1915 37.8626 29.1313 36.86 29.1313 35.6328V9.59288C29.1313 9.41329 29.0735 9.24867 28.9434 9.11398ZM21.7723 3.39718L26.9771 8.91943H22.6108C22.1482 8.91943 21.7723 8.51537 21.7723 8.0215V3.39718ZM27.8735 35.6029C27.8735 36.0967 27.4976 36.5008 27.0349 36.5008H3.61323C3.15058 36.5008 2.77468 36.0967 2.77468 35.6029V3.35228C2.77468 2.85842 3.15058 2.45435 3.61323 2.45435H20.5144V8.0215C20.5144 9.24867 21.4542 10.2514 22.6108 10.2514H27.859V35.6178L27.8735 35.6029Z" fill="white" />
        <path d="M5.66607 24.3787C5.66607 24.7678 5.96968 25.0821 6.34559 25.0821H24.3167C24.6926 25.0821 24.9962 24.7678 24.9962 24.3787C24.9962 23.9896 24.6926 23.6754 24.3167 23.6754H6.33113C5.95523 23.6754 5.65161 23.9896 5.65161 24.3787H5.66607Z" fill="white" />
        <path d="M24.3022 27.7759H6.33113C5.95523 27.7759 5.65161 28.0902 5.65161 28.4793C5.65161 28.8684 5.95523 29.1827 6.33113 29.1827H24.3022C24.6781 29.1827 24.9817 28.8684 24.9817 28.4793C24.9817 28.0902 24.6781 27.7759 24.3022 27.7759Z" fill="white" />
        <path d="M14.8613 31.8615H6.33113C5.95523 31.8615 5.65161 32.1758 5.65161 32.5649C5.65161 32.954 5.95523 33.2682 6.33113 33.2682H14.8613C15.2372 33.2682 15.5408 32.954 15.5408 32.5649C15.5408 32.1758 15.2372 31.8615 14.8613 31.8615Z" fill="white" />
      </g>
      <defs>
        <linearGradient id="paint0_linear_160_1040" x1="15.3673" y1="-1.27103e-05" x2="15.3673" y2="39" gradientUnits="userSpaceOnUse">
          <stop stop-color="#F98542" />
          <stop offset="1" stop-color="#F2600C" />
        </linearGradient>
        <linearGradient id="paint1_linear_160_1040" x1="15.3673" y1="-1.27103e-05" x2="15.3673" y2="39" gradientUnits="userSpaceOnUse">
          <stop stop-color="#F98542" />
          <stop offset="1" stop-color="#F2600C" />
        </linearGradient>
        <clipPath id="clip0_160_1040">
          <rect width="30" height="39" fill="white" transform="translate(0.360107)" />
        </clipPath>
      </defs>
    </svg>

  )
}

function IconSearch({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn('size-4', className)}
      viewBox="0 0 512 512"
      {...props}
    >
      <path d="M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z" />
    </svg>
  )
}

export const IconFileSearch = ({
  className,
  ...props
}: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8877 4.06055L9.12402 2.29688L10.5186 0.902344L9.12402 2.29688C9.00098 2.17383 8.83691 2.0918 8.67285 2.0918H3.21777C2.84863 2.0918 2.56152 2.41992 2.56152 2.74805V15.873C2.56152 16.2422 2.84863 16.5293 3.21777 16.5293H18.9678C19.2959 16.5293 19.624 16.2422 19.624 15.873V5.37305C19.624 5.04492 19.2959 4.7168 18.9678 4.7168H12.5283C11.9131 4.7168 11.3389 4.51172 10.8877 4.06055ZM12.2822 2.66602C12.3643 2.74805 12.4463 2.74805 12.5283 2.74805H18.9678C20.4033 2.74805 21.5928 3.9375 21.5928 5.37305V15.873C21.5928 17.3496 20.4033 18.498 18.9678 18.498H3.21777C1.74121 18.498 0.592773 17.3496 0.592773 15.873V2.74805C0.592773 1.3125 1.74121 0.123047 3.21777 0.123047H8.67285C9.37012 0.123047 10.0264 0.410156 10.5186 0.902344L12.2822 2.66602ZM14.374 9.9668H14.333C14.333 10.7051 14.1689 11.4023 13.7998 11.9766L15.3584 13.5762C15.7686 13.9453 15.7686 14.5605 15.3584 14.9707C14.9893 15.3398 14.374 15.3398 14.0049 14.9707L12.4053 13.3711C11.8311 13.7402 11.1338 13.9043 10.4365 13.9043C8.2627 13.9043 6.49902 12.1406 6.49902 9.9668C6.49902 7.79297 8.2627 6.0293 10.4365 6.0293C12.6104 6.0293 14.374 7.79297 14.374 9.9668ZM10.4365 7.99805C9.69824 7.99805 9.08301 8.4082 8.71387 8.98242C8.34473 9.59766 8.34473 10.377 8.71387 10.9512C9.08301 11.5664 9.69824 11.9355 10.4365 11.9355C11.1338 11.9355 11.749 11.5664 12.1182 10.9512C12.4873 10.377 12.4873 9.59766 12.1182 8.98242C11.749 8.4082 11.1338 7.99805 10.4365 7.99805Z"
        fill="black"
      />
    </svg>
  )
}

export const IconDocumentQuestion = ({
  className,
  ...props
}: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.8125 24.6562H15.8359C16.3281 25.4355 16.9434 26.0918 17.6816 26.625C17.5586 26.625 17.4355 26.625 17.3125 26.625H6.8125C5.33594 26.625 4.1875 25.4766 4.1875 24V8.25C4.1875 6.81445 5.33594 5.625 6.8125 5.625H13.5801C14.2773 5.625 14.9336 5.91211 15.4258 6.4043L19.1582 10.1367C19.6504 10.6289 19.9375 11.2852 19.9375 11.9824V13.7871C19.1992 13.9922 18.543 14.2793 17.9688 14.6895V12.1875H14.6875C13.9492 12.1875 13.375 11.6133 13.375 10.875V7.59375H6.8125C6.44336 7.59375 6.15625 7.92188 6.15625 8.25V24C6.15625 24.3691 6.44336 24.6562 6.8125 24.6562ZM21.9062 14.8125C23.998 14.8125 25.9258 15.9609 26.9922 17.7656C28.0586 19.6113 28.0586 21.8672 26.9922 23.6719C25.9258 25.5176 23.998 26.625 21.9062 26.625C19.7734 26.625 17.8457 25.5176 16.7793 23.6719C15.7129 21.8672 15.7129 19.6113 16.7793 17.7656C17.8457 15.9609 19.7734 14.8125 21.9062 14.8125ZM21.9062 24.6562C22.4395 24.6562 22.8906 24.2461 22.8906 23.6719C22.8906 23.1387 22.4395 22.6875 21.9062 22.6875C21.332 22.6875 20.9219 23.1387 20.9219 23.6719C20.9219 24.2461 21.332 24.6562 21.9062 24.6562ZM19.2812 18.832V19.0781C19.2812 19.4473 19.5684 19.7344 19.9375 19.7344C20.2656 19.7344 20.5938 19.4473 20.5938 19.0781V18.832C20.5938 18.627 20.7578 18.4219 20.9629 18.4219H22.6445C22.9316 18.4219 23.2188 18.709 23.2188 18.9961C23.2188 19.2422 23.0957 19.4062 22.8906 19.5293L21.5781 20.1855C21.373 20.3086 21.25 20.5547 21.25 20.8008V21.375C21.25 21.7441 21.5371 22.0312 21.9062 22.0312C22.2344 22.0312 22.5625 21.7441 22.5625 21.375V21.1699L23.5059 20.6777C24.1211 20.3496 24.5312 19.6934 24.5312 18.9961C24.5312 17.9707 23.6699 17.1504 22.6445 17.1504H20.9629C20.0195 17.1504 19.2812 17.8887 19.2812 18.832Z"
        fill="black"
      />
    </svg>
  )
}

export const IconFileText2 = ({
  className,
  ...props
}: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.75 24.6562H21.25C21.5781 24.6562 21.9062 24.3691 21.9062 24V12.1875H18.625C17.8867 12.1875 17.3125 11.6133 17.3125 10.875V7.59375H10.75C10.3809 7.59375 10.0938 7.92188 10.0938 8.25V24C10.0938 24.3691 10.3809 24.6562 10.75 24.6562ZM10.75 5.625H17.5176C18.2148 5.625 18.8711 5.91211 19.3633 6.4043L23.0957 10.1367C23.5879 10.6289 23.875 11.2852 23.875 11.9824V24C23.875 25.4766 22.6855 26.625 21.25 26.625H10.75C9.27344 26.625 8.125 25.4766 8.125 24V8.25C8.125 6.81445 9.27344 5.625 10.75 5.625ZM13.0469 16.125H18.9531C19.4863 16.125 19.9375 16.5762 19.9375 17.1094C19.9375 17.6836 19.4863 18.0938 18.9531 18.0938H13.0469C12.4727 18.0938 12.0625 17.6836 12.0625 17.1094C12.0625 16.5762 12.4727 16.125 13.0469 16.125ZM13.0469 20.0625H18.9531C19.4863 20.0625 19.9375 20.5137 19.9375 21.0469C19.9375 21.6211 19.4863 22.0312 18.9531 22.0312H13.0469C12.4727 22.0312 12.0625 21.6211 12.0625 21.0469C12.0625 20.5137 12.4727 20.0625 13.0469 20.0625Z"
        fill="black"
      />
    </svg>
  )
}

export const CrossIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4697 13.5303L13 14.0607L14.0607 13L13.5303 12.4697L9.06065 7.99999L13.5303 3.53032L14.0607 2.99999L13 1.93933L12.4697 2.46966L7.99999 6.93933L3.53032 2.46966L2.99999 1.93933L1.93933 2.99999L2.46966 3.53032L6.93933 7.99999L2.46966 12.4697L1.93933 13L2.99999 14.0607L3.53032 13.5303L7.99999 9.06065L12.4697 13.5303Z"
      fill="currentColor"
    />
  </svg>
);

export const MessageIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.8914 10.4028L2.98327 10.6318C3.22909 11.2445 3.5 12.1045 3.5 13C3.5 13.3588 3.4564 13.7131 3.38773 14.0495C3.69637 13.9446 4.01409 13.8159 4.32918 13.6584C4.87888 13.3835 5.33961 13.0611 5.70994 12.7521L6.22471 12.3226L6.88809 12.4196C7.24851 12.4724 7.61994 12.5 8 12.5C11.7843 12.5 14.5 9.85569 14.5 7C14.5 4.14431 11.7843 1.5 8 1.5C4.21574 1.5 1.5 4.14431 1.5 7C1.5 8.18175 1.94229 9.29322 2.73103 10.2153L2.8914 10.4028ZM2.8135 15.7653C1.76096 16 1 16 1 16C1 16 1.43322 15.3097 1.72937 14.4367C1.88317 13.9834 2 13.4808 2 13C2 12.3826 1.80733 11.7292 1.59114 11.1903C0.591845 10.0221 0 8.57152 0 7C0 3.13401 3.58172 0 8 0C12.4183 0 16 3.13401 16 7C16 10.866 12.4183 14 8 14C7.54721 14 7.10321 13.9671 6.67094 13.9038C6.22579 14.2753 5.66881 14.6656 5 15C4.23366 15.3832 3.46733 15.6195 2.8135 15.7653Z"
        fill="currentColor"
      />
    </svg>
  );
};


export const UndoIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 8C13.5 4.96643 11.0257 2.5 7.96452 2.5C5.42843 2.5 3.29365 4.19393 2.63724 6.5H5.25H6V8H5.25H0.75C0.335787 8 0 7.66421 0 7.25V2.75V2H1.5V2.75V5.23347C2.57851 2.74164 5.06835 1 7.96452 1C11.8461 1 15 4.13001 15 8C15 11.87 11.8461 15 7.96452 15C5.62368 15 3.54872 13.8617 2.27046 12.1122L1.828 11.5066L3.03915 10.6217L3.48161 11.2273C4.48831 12.6051 6.12055 13.5 7.96452 13.5C11.0257 13.5 13.5 11.0336 13.5 8Z"
      fill="currentColor"
    />
  </svg>
);

export const RedoIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 8C2.5 4.96643 4.97431 2.5 8.03548 2.5C10.5716 2.5 12.7064 4.19393 13.3628 6.5H10.75H10V8H10.75H15.25C15.6642 8 16 7.66421 16 7.25V2.75V2H14.5V2.75V5.23347C13.4215 2.74164 10.9316 1 8.03548 1C4.1539 1 1 4.13001 1 8C1 11.87 4.1539 15 8.03548 15C10.3763 15 12.4513 13.8617 13.7295 12.1122L14.172 11.5066L12.9609 10.6217L12.5184 11.2273C11.5117 12.6051 9.87945 13.5 8.03548 13.5C4.97431 13.5 2.5 11.0336 2.5 8Z"
      fill="currentColor"
    />
  </svg>
);

export const DeltaIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.67705 15H1L1.75 13.5L6.16147 4.67705L6.15836 4.67082L6.16667 4.66667L7.16147 2.67705L8 1L8.83853 2.67705L14.25 13.5L15 15H13.3229H2.67705ZM7 6.3541L10.5729 13.5H3.42705L7 6.3541Z"
      fill="currentColor"
    />
  </svg>
);

export const CopyIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75 0.5C1.7835 0.5 1 1.2835 1 2.25V9.75C1 10.7165 1.7835 11.5 2.75 11.5H3.75H4.5V10H3.75H2.75C2.61193 10 2.5 9.88807 2.5 9.75V2.25C2.5 2.11193 2.61193 2 2.75 2H8.25C8.38807 2 8.5 2.11193 8.5 2.25V3H10V2.25C10 1.2835 9.2165 0.5 8.25 0.5H2.75ZM7.75 4.5C6.7835 4.5 6 5.2835 6 6.25V13.75C6 14.7165 6.7835 15.5 7.75 15.5H13.25C14.2165 15.5 15 14.7165 15 13.75V6.25C15 5.2835 14.2165 4.5 13.25 4.5H7.75ZM7.5 6.25C7.5 6.11193 7.61193 6 7.75 6H13.25C13.3881 6 13.5 6.11193 13.5 6.25V13.75C13.5 13.8881 13.3881 14 13.25 14H7.75C7.61193 14 7.5 13.8881 7.5 13.75V6.25Z"
      fill="currentColor"
    />
  </svg>
);
export const ArrowUpIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70711 1.39644C8.31659 1.00592 7.68342 1.00592 7.2929 1.39644L2.21968 6.46966L1.68935 6.99999L2.75001 8.06065L3.28034 7.53032L7.25001 3.56065V14.25V15H8.75001V14.25V3.56065L12.7197 7.53032L13.25 8.06065L14.3107 6.99999L13.7803 6.46966L8.70711 1.39644Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const StopIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3H13V13H3V3Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const PenIcon = ({ className, ...props }: React.ComponentProps<'svg'>) => (
  <svg
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    className={cn('size-4', className)}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 0.189331L9.28033 0.719661L15.2803 6.71966L15.8107 7.24999L15.2803 7.78032L13.7374 9.32322C13.1911 9.8696 12.3733 9.97916 11.718 9.65188L9.54863 13.5568C8.71088 15.0648 7.12143 16 5.39639 16H0.75H0V15.25V10.6036C0 8.87856 0.935237 7.28911 2.4432 6.45136L6.34811 4.28196C6.02084 3.62674 6.13039 2.80894 6.67678 2.26255L8.21967 0.719661L8.75 0.189331ZM7.3697 5.43035L10.5696 8.63029L8.2374 12.8283C7.6642 13.8601 6.57668 14.5 5.39639 14.5H2.56066L5.53033 11.5303L4.46967 10.4697L1.5 13.4393V10.6036C1.5 9.42331 2.1399 8.33579 3.17166 7.76259L7.3697 5.43035ZM12.6768 8.26256C12.5791 8.36019 12.4209 8.36019 12.3232 8.26255L12.0303 7.96966L8.03033 3.96966L7.73744 3.67677C7.63981 3.57914 7.63981 3.42085 7.73744 3.32321L8.75 2.31065L13.6893 7.24999L12.6768 8.26256Z"
      fill="currentColor"
    />
  </svg>
);

export const SummarizeIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.75 12H1V10.5H1.75H5.25H6V12H5.25H1.75ZM1.75 7.75H1V6.25H1.75H4.25H5V7.75H4.25H1.75ZM1.75 3.5H1V2H1.75H7.25H8V3.5H7.25H1.75ZM12.5303 14.7803C12.2374 15.0732 11.7626 15.0732 11.4697 14.7803L9.21967 12.5303L8.68934 12L9.75 10.9393L10.2803 11.4697L11.25 12.4393V2.75V2H12.75V2.75V12.4393L13.7197 11.4697L14.25 10.9393L15.3107 12L14.7803 12.5303L12.5303 14.7803Z"
      fill="currentColor"
    />
  </svg>
);


export const LoaderIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <g clipPath="url(#clip0_2393_1490)">
        <path d="M8 0V4" stroke="currentColor" strokeWidth="1.5" />
        <path
          opacity="0.5"
          d="M8 16V12"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          opacity="0.9"
          d="M3.29773 1.52783L5.64887 4.7639"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          opacity="0.1"
          d="M12.7023 1.52783L10.3511 4.7639"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          opacity="0.4"
          d="M12.7023 14.472L10.3511 11.236"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          opacity="0.6"
          d="M3.29773 14.472L5.64887 11.236"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          opacity="0.2"
          d="M15.6085 5.52783L11.8043 6.7639"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          opacity="0.7"
          d="M0.391602 10.472L4.19583 9.23598"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M15.6085 10.4722L11.8043 9.2361"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          opacity="0.8"
          d="M0.391602 5.52783L4.19583 6.7639"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_2393_1490">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ClockRewind = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.96452 2.5C11.0257 2.5 13.5 4.96643 13.5 8C13.5 11.0336 11.0257 13.5 7.96452 13.5C6.12055 13.5 4.48831 12.6051 3.48161 11.2273L3.03915 10.6217L1.828 11.5066L2.27046 12.1122C3.54872 13.8617 5.62368 15 7.96452 15C11.8461 15 15 11.87 15 8C15 4.13001 11.8461 1 7.96452 1C5.06835 1 2.57851 2.74164 1.5 5.23347V3.75V3H0V3.75V7.25C0 7.66421 0.335786 8 0.75 8H3.75H4.5V6.5H3.75H2.63724C3.29365 4.19393 5.42843 2.5 7.96452 2.5ZM8.75 5.25V4.5H7.25V5.25V7.8662C7.25 8.20056 7.4171 8.51279 7.6953 8.69825L9.08397 9.62404L9.70801 10.0401L10.5401 8.79199L9.91603 8.37596L8.75 7.59861V5.25Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

const IconCalendar = ({ className, ...props }: React.ComponentProps<'svg'>) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={cn('size-4', className)}
      {...props}
    >
      <path
        d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
        fill="currentColor"
      />
    </svg>
  );
};

const IconClock = ({ className, ...props }: React.ComponentProps<'svg'>) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={cn('size-4', className)}
      {...props}
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
        fill="currentColor"
      />
    </svg>
  );
};

const IconDollarSign = ({ className, ...props }: React.ComponentProps<'svg'>) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={cn('size-4', className)}
      {...props}
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"
        fill="currentColor"
      />
    </svg>
  );
};

const IconPencil = PenIcon;

export {
  IconEdit,
  IconNextChat,
  IconOpenAI,
  IconVercel,
  IconGitHub,
  IconSeparator,
  IconArrowDown,
  IconArrowRight,
  IconUser,
  IconPlus,
  IconPlusCircle,
  IconArrowElbow,
  IconSpinner,
  IconMessage,
  IconTrash,
  IconRefresh,
  IconStop,
  IconSidebar,
  IconMoon,
  IconSun,
  IconCopy,
  IconCheck,
  IconDownload,
  IconClose,
  IconShare,
  IconUsers,
  IconExternalLink,
  IconChevronUpDown,
  IconRobot,
  IconMatter,
  IconSmokeballLogo,
  IconArchieAvatar,
  IconArchieText,
  IconArchieDraft,
  IconSearch,
  IconChevronDown,
  IconCalendar,
  IconClock,
  IconDollarSign,
  IconPencil,
}
